// Please update the colors in ./theme.js and ./global.scss
// whenever we change this object
export const colors = {
  fullBlack: '#000',
  black: 'rgba(0, 0, 0, 0.85)',
  checkGreen: '#52C41A',
  divider: '#d9d9d9',
  'placeholder-color': 'rgba(0, 0, 0, 0.25)',
  'light-gray': '#fafafa',
  'neutral-gray': '#f5f5f5',
  'dark-gray': '#f0f0f0',
  primary: '#f46036',
  'secondary-text': 'rgba(0, 0, 0, 0.45)',
  'title-black': 'rgba(23, 17, 35, 0.85)',
  tooltipBlack: 'rgba(0, 0, 0, 0.85)',
  volcano: '#ffd8bf',
  'positive-1': '#F4FFF2',
  'positive-30': '#B3E0BA',
  'positive-50': '#79C886',
  'positive-60': '#049B22',
  'warning-1': '#FFFBF2',
  'warning-10': '#FFEDD9',
  'warning-20': '#FBE1C5',
  'warning-30': '#F8CD9F',
  'warning-40': '#F6BA79',
  'warning-50': '#F3A653',
  warning: '#FAAD14',
  informative: '#488BE8',
  'error-1': '#FFF2F3',
  'error-40': '#F4737E',
  'error-60': '#B1000F',
  white: 'white',
  'remove-button': '#8e9094',
  'tekhelet-purple': '#160F2F',
  'tekhelet-purple-40': '#4A35A3',
  'tekhelet-purple-30': '#5840C1',
  'tekhelet-purple-20': '#735FCB',
  'tekhelet-purple-10': '#8E7DD5',
  'tekhelet-purple-5': '#9C8DDA',
  'space-cadet': '#18203D',
  'royal-purple-80': '#351E53',
  'royal-purple-50': '#8657C2',
  'royal-purple-5': '#E7DEF3',
  'background-royal-purple': '#FAF7FF',
  'tomato-40': '#F68261',
  'tomato-50': '#F4633A',
  'background-brand-1': '#F8F9FB',
  'description-font-or-disabled': '#B6C2D3',
  'tag-input-description-color': '#bfbfbf',
  'tag-input-item-border': '#F0F0F0',
  ratingYellow: '#FADB14',
  label: '#F3F5FA',
  'positive-40': '#96D4A0',
  danger: '#FF4D4F',
  colorText: '#18203D',
}
